/* eslint-disable no-return-assign */
import { useNamespace } from '@ibiz-template/vue3-util';
import { defineComponent, computed, ref, Ref, watch } from 'vue';
import { getAllFilterModes } from '../../../util';

export const FilterModeSelect = defineComponent({
  name: 'IBizFilterModeSelect',
  props: {
    value: String,
    modes: Array<string>,
    disabled: Boolean,
  },
  emits: {
    change: (_mode: string) => true,
  },
  setup(props, { emit }) {
    const showPicker = ref(false);

    const FilterModes = getAllFilterModes();

    const ns = useNamespace(`filter-mode-select`);
    /** 显示可选的过滤类型 */
    const availableModes = computed(() => {
      if (props.modes?.length) {
        return FilterModes.filter(item =>
          props.modes!.includes(item.valueOP),
        ).map(x => {
          return {
            text: x.label,
            value: x.valueOP,
          };
        });
      }
      return FilterModes.map(x => {
        return {
          text: x.label,
          value: x.valueOP,
        };
      });
    });

    // 当前值
    const valueText: Ref<string> = ref('');

    watch(
      () => props.value,
      newVal => {
        if (newVal || newVal === null) {
          const index = FilterModes.findIndex(
            (item: IData) => item.valueOP === props.value,
          );
          if (index !== -1) {
            valueText.value = FilterModes[index].label;
          }
          if (newVal === null) {
            valueText.value = '';
          }
        }
      },
      { immediate: true, deep: true },
    );

    /**
     * 选择变更处理
     * @author lxm
     * @date 2023-10-16 04:54:58
     * @param {string} value
     */
    const onChange = ({ selectedOptions }: { selectedOptions: IData[] }) => {
      showPicker.value = false;
      if (Array.isArray(selectedOptions)) {
        emit('change', selectedOptions[0].value);
      }
    };

    const openPopup = () => {
      if (props.disabled) {
        return;
      }
      showPicker.value = true;
    };

    return { ns, availableModes, showPicker, valueText, onChange, openPopup };
  },
  render() {
    return (
      <div class={this.ns.b()}>
        <van-field
          v-model={this.valueText}
          is-link
          readonly
          label={ibiz.i18n.t('control.searchBar.operate')}
          onClick={this.openPopup}
        />
        <van-popup
          round
          teleport='body'
          position='bottom'
          v-model:show={this.showPicker}
        >
          <van-picker
            columns={this.availableModes}
            onCancel={() => {
              this.showPicker = false;
            }}
            onConfirm={this.onChange}
          />
        </van-popup>
      </div>
    );
  },
});
